<ng-container *ngIf="!storageService.detectMob()" [ngTemplateOutlet]="webViewContent"></ng-container>

<ng-container *ngIf="storageService.detectMob()" [ngTemplateOutlet]="mobileViewContent"></ng-container>

<ng-template #mobileViewContent>
  <hr />
  <div class="d-block w-100">
    <div class="d-flex mobile-view-header-content">
      <ng-container [ngTemplateOutlet]="webViewContent"></ng-container>
    </div>

    <div
      *ngIf="user && user.role_id !== userRoles.TEACHER_ONLY"
      class="w-100 mobile-view-select-school-content d-flex align-items-center justify-content-center"
    >
      <ngx-select-header-school></ngx-select-header-school>
    </div>
  </div>
</ng-template>

<ng-template #webViewContent>
  <div class="header-container" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="logo-container">
      <a
        class="sidebar-toggle cursor-pointer"
        matRipple
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
        (click)="toggleSidebar()"
        [title]="openSidebar ? 'Close Expand View' : 'Expand Menu'"
        href="#"
        aria-label="Toggle Sidebar"
      >
        <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
      </a>

      <a class="logo quicksand-bold-label" href="#" (click)="navigateHome()" *ngIf="user && user?.role_id !== userRoles.TEACHER_ONLY">
        <img *ngIf="!storageService.detectMob()" src="/assets/images/RespondEDU-Portal-Logo.svg" alt="logo-img" height="70" width="180" />
      </a>
      <a
        class="logo quicksand-bold-label"
        href="/test-quizzes/classroom-details/teacher-classroom/true"
        *ngIf="user && user?.role_id === userRoles.TEACHER_ONLY"
      >
        <img
          *ngIf="!storageService.detectMob()"
          src="/assets/images/Teacher-only-white-logo.svg"
          alt="logo-img"
          height="50"
          width="130"
          class="techer-only-logo"
        />
      </a>

      <img
        *ngIf="user?.is_trial_user"
        src="/assets/images/trail-period-svg2.svg"
        alt="free-trial"
        height="80"
        width="100"
        style="border-radius: 50%"
        class="trial-period"
      />
    </div>
  </div>

  <div [ngStyle]="{ display: storageService.detectMob() ? 'none' : 'd-flex align-items-center ' }" class="my-auto">
    <div class=" {{ user?.profileData?.isViewMultipleSchools === true || user?.role_id === 19 ? 'cursor-pointer' : '' }}">
      <ngx-select-header-school></ngx-select-header-school>
    </div>
  </div>

  <div class="header-container" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <nb-actions size="small" [ngClass]="storageService.detectMob() ? 'mobile-action-menu' : ''">
      <nb-action>
        <div
          *ngIf="!user?.is_trial_user && user?.role_id !== userRoles.TEACHER_ONLY"
          class="user-role-name justify-content-center quicksand-bold-label d-flex cursor-pointer"
        >
          {{ user?.role?.name }}

          <img
            src="/assets/icons/i.svg"
            alt="change-role"
            height="12"
            width="12"
            class="ml-1 change-role-select cursor-pointer"
            *ngIf="user?.is_trial_user"
          />
        </div>
        <div
          *ngIf="user?.is_trial_user"
          [matMenuTriggerFor]="changeRole"
          class="user-role-name justify-content-center quicksand-bold-label d-flex cursor-pointer"
        >
          {{ user?.role?.name }}

          <img
            src="/assets/icons/i.svg"
            alt="change-role"
            height="12"
            width="12"
            class="ml-1 change-role-select cursor-pointer"
            *ngIf="user?.is_trial_user"
          />
        </div>

        <mat-menu #changeRole="matMenu" Position="before" class="change-role-menu-content">
          <button
            mat-menu-item
            class="btn-mat-menu"
            *ngFor="let role of changeTrialUserRoles"
            style="width: 10rem; height: 50px"
            (click)="changeUserRoleInLocal(role)"
          >
            <label data-child="true" class="cursor-pointer menu-label quicksand-bold-label">{{ role.name }}</label>
          </button>
        </mat-menu>
      </nb-action>

      <nb-action
        *ngIf="!storageService.detectMob() && user?.role_id !== userRoles.TEACHER_ONLY"
        class="control-item"
        icon="email-outline"
        matRipple
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
        (click)="navigateHeader('/messaging')"
        aria-label="Open Messaging"
      ></nb-action>

      <nb-action
        *ngIf="user?.role_id !== userRoles.TEACHER_ONLY"
        class="control-item"
        icon="bell-outline"
        [nbBadgeDot]="badgeVisible"
        badgeDot
        badgePosition="top right"
        [badgeStatus]="badgeVisible ? 'danger' : null"
        (click)="getNotifications()"
        [matMenuTriggerFor]="menu"
      >
      </nb-action>

      <!-- <nb-action
        *ngIf="user?.role_id !== 22"
        class="control-item"
        icon="bell-outline"
        matRipple
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
        (click)="getNotifications()"
        mat-button
        [badgeDot]="storageService.isBadge"
        badgePosition="top right"
        badgeStatus="danger"
        size="tiny"
        [matMenuTriggerFor]="menu"
        aria-label="Open Notifications"
      >
      </nb-action> -->

      <mat-menu #menu="matMenu" class="custom-menub notifications-menu">
        <div class="p-2" [ngClass]="analyticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''">
          <div
            class="quicksand-bold-label pl-1"
            [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme-border' : 'border-line'"
          >
            <label class="notification-label">Notifications</label>
            <label
              (click)="
                storageService.setItem('isUnreadNotifications', false); storageService.isBadge = false; updateMultipleNotifications()
              "
              class="notification-label-mark-all cursor-pointer float-right"
              *ngIf="notifications?.length > 0"
              >Mark all as read</label
            >
          </div>
          <div *ngFor="let notification of notifications">
            <div
              class="d-flex w-100"
              [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme-border' : 'border-lifne'"
              (click)="router.navigateByUrl('/notifications')"
            >
              <div class="pt-1">
                <img
                  src="/assets/images/respond-edu.svg"
                  alt="respond-edu"
                  class="notification-img"
                  *ngIf="!notification.img && notification.read_status === true"
                  height="55"
                  width="55"
                />
                <img
                  src="/assets/images/favicon1.png"
                  alt="respond-edu"
                  class="notification-img"
                  *ngIf="!notification.img && notification.read_status === false"
                  height="55"
                  width="55"
                />
              </div>
              <div class="pl-2">
                <label class="quicksand-bold-label mt-1 notification-message-title">{{ notification?.title }}</label>
                <label class="quicksand-normal-label notification-message-label">{{ notification?.message }}</label>

                <label class="quicksand-bold-label notification-message-time">
                  {{ notification.created_at }}
                </label>
              </div>
            </div>
          </div>
          <div class="text-center quicksand-bold-label m-auto" *ngIf="notifications && notifications.length === 0">
            <img src="/assets/images/respond-edu.svg" alt="responed-edu" height="100" width="100" loading="lazy" />
            <br />
            No Notifications Found!
          </div>
          <label
            class="see-all-notifications cursor-pointer quicksand-bold-label"
            (click)="
              storageService.setItem('isUnreadNotifications', false); storageService.isBadge = false; router.navigateByUrl('/notifications')
            "
          >
            See All
          </label>
        </div>
      </mat-menu>

      <nb-action
        class="user-action {{ user?.role_id === userRoles.TEACHER_ONLY ? 'border-0' : '' }}"
        *nbIsGranted="['view', 'user']"
        matRipple
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
      >
        <nb-user
          [nbContextMenu]="userMenu"
          [onlyPicture]="userPictureOnly"
          [name]="(user ? user?.firstName + ' ' + user?.lastName : 'User') | titlecase"
          [picture]="user && user.user_profile_media ? user.user_profile_media.image.url : '/assets/images/profile.png'"
          class="img-fluid user-profile-nebular-user"
        >
        </nb-user>
        <!-- <span id="status-indicator" class="dot"></span> -->
      </nb-action>
    </nb-actions>
  </div>
</ng-template>

<!-- dialog for start assessment -->
<ng-template #startAssessment>
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="text-center">
      <img src="/assets/images/ic-student.svg" height="150" width="150" alt="delete-icon" />

      <br />
      <label class="label-delete-lesson-plan quicksand-bold-label">Start Assessment</label>
      <br />
      <label class="label-delete-lesson-plan quicksand-bold-label"
        >Start the assessment
        <span *ngIf="currentAssessment?.isReactivate === true">again</span>
        which has been
        <span *ngIf="currentAssessment?.isReactivate === false">started </span>
        <span *ngIf="currentAssessment?.isReactivate === true">reactivated</span>
        by your school teacher
      </label>
    </div>
    <div class="d-flex">
      <button
        nbButton
        color="warn"
        class="start-assessment mt-4 w-100 quicksand-bold-label text-capitalize text-white"
        (click)="dialog.closeAll(); renderToTakeAssessment()"
      >
        Start
      </button>
    </div>
  </div>
</ng-template>
